import{gql as o}from"@apollo/client";const t=o`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;export{t as FORGOT_PASSWORD_MUTATION};
//# sourceMappingURL=useForgotPassword.graphql.js.map
